// extracted by mini-css-extract-plugin
export default {"form-section":"InternalUserInfoForm_form-section__tVQyk","form-check":"InternalUserInfoForm_form-check__O6H66"};